import { Item } from '../Item/Item.js'

function List(params) {
  return (
    <div>
      {params.items.map((item) => (
        <Item
          key={item.id}
          item={item}
          onClick={params.onItemClick}
          onDelete={params.onItemDelete}
        />
      ))}
    </div>
  )
}

export default List;